import { render, staticRenderFns } from "./DeleteZoneDialog.vue?vue&type=template&id=1ad5f7e8&scoped=true"
import script from "./DeleteZoneDialog.vue?vue&type=script&lang=js"
export * from "./DeleteZoneDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad5f7e8",
  null
  
)

export default component.exports